export default __webpack_public_path__ + "static/media/CartadeConformaciondeGrupo_2025.ee76665a.docx";